import { router } from 'expo-router';
import * as React from 'react';
import { Platform } from 'react-native';
import {
    BodyLargeRegular,
    H5Emphasized,
    Icon,
    isWeb,
    UserSearchIcon,
    View,
    YStack,
} from 'smoothie';

import KycButton from './KycButton';

const UnderReview = () => {
    const shadowStyle = Platform.select({
        ios: {
            shadowColor: 'rgba(0, 0, 0, 0.05)',
            shadowOffset: {
                width: 0,
                height: 5,
            },
            shadowOpacity: 0.05,
            shadowRadius: 10,
        },
        android: {
            elevation: 5,
        },
    });

    return (
        <YStack
            flex={1}
            justifyContent={isWeb ? 'flex-start' : 'space-between'}
        >
            <View>
                <View
                    alignSelf="center"
                    padding={20}
                    borderRadius={20}
                    backgroundColor="$orange500"
                    marginTop={30}
                    marginBottom={30}
                    style={{ ...shadowStyle }}
                >
                    <Icon icon={UserSearchIcon} color="$black" size={40} />
                </View>
                <H5Emphasized textAlign="center" marginBottom={14}>
                    Under review
                </H5Emphasized>
                <BodyLargeRegular textAlign="center" color="$gray1100">
                    A Fruitful team member may reach out for additional
                    information.
                </BodyLargeRegular>
            </View>
            <KycButton
                onPress={() => {
                    router.replace('/home/banking');
                }}
                text="Done"
                hideSecureText
            />
        </YStack>
    );
};

export default UnderReview;
